"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const styles_1 = require("@material-ui/styles");
const core_1 = require("@material-ui/core");
const SearchIcon_1 = __importDefault(require("../../../svgIcons/SearchIcon"));
const CloseIcon_1 = __importDefault(require("../../../svgIcons/CloseIcon"));
require("./searchbar.scss");
const common_1 = require("../../../utils/common");
const useTreeStyles = {
    input: {
        backgroundColor: 'white',
        fontSize: 14
    }
};
class SearchBar extends react_1.Component {
    constructor(props) {
        super(props);
        this.clearInput = () => {
            this.setState({ searchValue: '' });
            this.props.handleInputChange('');
        };
        this.cancelSearch = () => {
            this.clearInput();
            this.setState({ cancelSearchActive: false });
        };
        this.state = {
            cancelSearchActive: false,
            searchValue: ''
        };
        this.query = debounce_1.default(this.query, 700);
    }
    query(query) {
        this.props.handleInputChange(query);
    }
    render() {
        const { classes, className } = this.props;
        const { searchValue, cancelSearchActive } = this.state;
        return (react_1.default.createElement("div", { className: `search-bar-box w-100 ${className}`, style: this.props.style },
            react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'medium', id: 'payment-history-search-input', className: 'search-field', placeholder: 'Search', onChange: (e) => {
                    this.setState({ searchValue: e.target.value });
                    this.query(e.target.value);
                }, onFocus: () => {
                    if (common_1.ifIos()) {
                        window.scrollTo(0, 0);
                    }
                    this.setState({ cancelSearchActive: true });
                }, value: searchValue, variant: "outlined", InputProps: {
                    classes: {
                        root: classes.input
                    },
                    startAdornment: react_1.default.createElement(SearchIcon_1.default, { className: 'v2-search-icon', style: { fontSize: '14px' } }),
                    endAdornment: react_1.default.createElement("div", null, searchValue && react_1.default.createElement(CloseIcon_1.default, { onClick: this.clearInput, className: "close-icon", style: {
                            fontSize: '8px',
                            cursor: "pointer"
                        } }))
                } }),
            react_1.default.createElement(core_1.Hidden, { smUp: true }, cancelSearchActive &&
                react_1.default.createElement("span", { onClick: this.cancelSearch, className: "cancel-search" }, "Cancel"))));
    }
}
exports.default = (styles_1.withStyles(useTreeStyles)(SearchBar));
